import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { User, UserManager } from 'oidc-client';
import { AppDispatch, ApplicationState } from '../store';
import AsyncStatus from '../model/common/AsyncStatus';
import userStore, { remoteSignout } from '../store/User';

interface UserProviderProps {
    userManager: UserManager,
    children: React.ReactElement
}

const UserProvider = function ({userManager, children}: UserProviderProps) {
  const dispatch : AppDispatch = useDispatch();
  const loadStatus = useSelector<ApplicationState, AsyncStatus>(state => state.user.loadStatus);
  const signinRedirectStatus = useSelector<ApplicationState, AsyncStatus>(state => state.user.signinRedirectStatus);
  const user = useSelector<ApplicationState, User | null>(state => state.user.user);
  
  const onSilentRenewError = (error: Error) => dispatch(userStore.actions.silentRenewErrored(error));
  const onAccessTokenExpired = () => dispatch(userStore.actions.userExpired());
  const onUserLoaded = (user: User) => dispatch(userStore.actions.userRefreshed(user));
  const onUserSignedOut = () => dispatch(remoteSignout());

  useEffect(() => {
    userManager.events.addSilentRenewError(onSilentRenewError);
    userManager.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.events.addUserLoaded(onUserLoaded);
    userManager.events.addUserSignedOut(onUserSignedOut);
    return () => {
        userManager.events.removeSilentRenewError(onSilentRenewError);
        userManager.events.removeAccessTokenExpired(onAccessTokenExpired);
        userManager.events.removeUserLoaded(onUserLoaded);
        userManager.events.addUserSignedOut(onUserSignedOut);
    }
  }, [userManager]);
  
  return children;
}

export default UserProvider;